import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilm, faFire } from '@fortawesome/free-solid-svg-icons';
import React, { useContext } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { MovieContext } from '../Context';


const Footer = () => {

  const { API_KEY } = useContext(MovieContext);
  const { API_URL } = useContext(MovieContext); 
  const { movies } = useContext(MovieContext);
  const { getMovies } = useContext(MovieContext); 
  const { movieURL } = useContext(MovieContext);
  const { setMovieURL } = useContext(MovieContext);

  const navigate = useNavigate();

  const trending = () => {
    setMovieURL(API_URL);
    getMovies(API_URL);
    return movies;
  }

  const nowPlaying = () => {
    const query = 'https://api.themoviedb.org/3/movie/now_playing?'+API_KEY+'&language=en-US';
    setMovieURL(query);
    getMovies(query);
    return movies;
  } 

  return (
    <div className='menu-bar'>
        <ul className='menu'>
            <li><NavLink to="/projects/mymdb" onClick={trending}><FontAwesomeIcon icon={faFire}/><span>Trending</span></NavLink></li>
            <li><NavLink to="/projects/now-playing" onClick={nowPlaying}><FontAwesomeIcon icon={faFilm}/><span>Now Playing</span></NavLink></li>
        </ul>
    </div>
  )
}

export default Footer